function getFabricPattern(fabric){

  switch(fabric){

    case "gingham-blue":
      return `
        <pattern id="fabricPattern"
                 width="20"
                 height="20"
                 patternUnits="userSpaceOnUse">

          <rect width="20" height="20" fill="white"/>

          <rect width="10" height="20"
                fill="rgba(111,159,216,.45)"/>

          <rect width="20" height="10"
                fill="rgba(111,159,216,.45)"/>

        </pattern>
      `;

    case "gingham-red":
      return `
        <pattern id="fabricPattern"
                 width="20"
                 height="20"
                 patternUnits="userSpaceOnUse">

          <rect width="20" height="20" fill="#fff8f8"/>

          <rect width="10" height="20"
                fill="rgba(214,111,111,.55)"/>

          <rect width="20" height="10"
                fill="rgba(214,111,111,.55)"/>

        </pattern>
      `;

    case "gingham-pink":
      return `
        <pattern id="fabricPattern"
                 width="20"
                 height="20"
                 patternUnits="userSpaceOnUse">

          <rect width="20" height="20" fill="#fff7fb"/>

          <rect width="10" height="20"
                fill="rgba(225,106,168,.55)"/>

          <rect width="20" height="10"
                fill="rgba(225,106,168,.55)"/>

        </pattern>
      `;

    default:
      return null;
  }

}
function applyFabricToText(fabric){

  const activeLayer =
document.querySelector(
".embroidery-text-layer.active-layer"
);

console.log(
"FOUND ACTIVE LAYER",
activeLayer
);

if(!activeLayer) return;

  const activeText =
    activeLayer.querySelector(
      ".text-content"
    );

  if(!activeText) return;

  activeText
    .querySelectorAll(".curve-letter")
    .forEach(letter => {
        console.log(
"APPLYING FABRIC TO",
letter
);

      letter.classList.remove(
  "fabric-text",
  "fabric-gingham-blue",
  "fabric-gingham-red",
  "fabric-gingham-pink",
  "fabric-burlap",
  "fabric-leopard",
  "fabric-cheetah"
);

      if(!fabric){

  activeLayer.dataset.applique = "";

  return;

}

      letter.classList.add("fabric-text");
letter.classList.add(
  "fabric-" + fabric
);
      activeLayer.dataset.applique = fabric;

    });

}

document.addEventListener("DOMContentLoaded", () => {

  document
    .querySelectorAll(".fabric-card")
    .forEach(card => {

      card.addEventListener("click", () => {

  const appliqueInput =
    document.getElementById("appliqueType");

  const currentFabric =
    appliqueInput.value;

  const clickedFabric =
    card.dataset.fabric;

  if(currentFabric === clickedFabric){

    appliqueInput.value = "";

    applyFabricToText("");

    console.log("APPLIQUE REMOVED");

  } else {

    appliqueInput.value = clickedFabric;

    applyFabricToText(clickedFabric);

    console.log(
      "APPLIQUE ADDED",
      clickedFabric
    );

  }

  document.dispatchEvent(
    new Event("embroideryUpdated")
  );



        

      });

    });
    

});